export const EPR_SERVICE = "/epr-sb/v0";

export const EPR_OVERVIEW = `${EPR_SERVICE}/epr_overview`;
export const TEACHERS_BY_LOCATION_READ = `${EPR_OVERVIEW}/teachers/`;
export const REGION_LOCATION_METRICS_READ = `${EPR_OVERVIEW}/region/locations/metrics.json`;
